import {
  RATING_COLOR_1,
  RATING_COLOR_2,
  RATING_COLOR_3,
  RATING_COLOR_4,
  RATING_COLOR_5,
} from '../config/colors';
import { ProductVariant } from '../types';

export function chunk<T>(array: T[], size: number): T[][] {
  const ret = [];
  for (let i = 0; i < array.length; i += size) {
    ret.push(array.slice(i, i + size));
  }
  return ret;
}

export function calculateDiscount(
  originalPrice: number,
  discountPrice: number,
): number {
  return parseInt(
    `${((originalPrice - discountPrice) / originalPrice) * 100}`,
    10,
  );
}

export function getRatingColor(rating: number): string {
  if (rating > 0 && rating <= 1.5) {
    return RATING_COLOR_1;
  } else if (rating > 1.5 && rating <= 2.4) {
    return RATING_COLOR_2;
  } else if (rating > 2.4 && rating <= 3.4) {
    return RATING_COLOR_3;
  } else if (rating > 3.4 && rating <= 4.4) {
    return RATING_COLOR_4;
  }

  return RATING_COLOR_5;
}

export function findMatchingVariant(
  variants: ProductVariant[],
  options: Record<string, number>,
): ProductVariant | null {
  for (let i = 0; i < variants.length; i++) {
    let found = true;
    const variant = variants[i];
    Object.keys(options).forEach((key) => {
      const option = variant.optionValues.find(
        (option) => option.id === options[key],
      );
      if (!option) {
        found = false;
      }
    });
    if (found) return variant;
  }
  return null;
}

export function formatJoiError(error: any): Record<string, string> {
  const ret: any = {};
  Object.keys(error.details).forEach((key) => {
    ret[key] = error.details[key][0];
  });

  return ret;
}
